import { Skeleton } from '@nextui-org/react'

export function OrderSummaryLoader() {
  return (
    <div className="grid gap-4">
      <div className="flex justify-between gap-6">
        <Skeleton className="w-1/6">
          <div className="h-4 w-1/6 bg-default-200"></div>
        </Skeleton>
        <Skeleton className="w-1/6">
          <div className="h-4 w-1/6 bg-default-200"></div>
        </Skeleton>
      </div>
      <div className="flex justify-between">
        <Skeleton className="w-2/6">
          <div className="h-4 w-2/6 bg-default-200"></div>
        </Skeleton>
        <Skeleton className="w-2/6">
          <div className="h-4 w-2/6 bg-default-200"></div>
        </Skeleton>
      </div>
      <div className="flex justify-between">
        <Skeleton className="w-1/6">
          <div className="h-4 w-1/6 bg-default-200"></div>
        </Skeleton>
        <Skeleton className="w-2/6">
          <div className="h-4 w-2/6 bg-default-200"></div>
        </Skeleton>
      </div>
      <div className="flex justify-between">
        <Skeleton className="w-2/6">
          <div className="h-4 w-2/6 bg-default-200"></div>
        </Skeleton>
        <Skeleton className="w-1/6">
          <div className="h-4 w-1/6 bg-default-200"></div>
        </Skeleton>
      </div>
      <div className="flex justify-between">
        <Skeleton className="w-2/6">
          <div className="h-4 w-2/6 bg-default-200"></div>
        </Skeleton>
        <Skeleton className="w-2/6">
          <div className="h-4 w-2/6 bg-default-200"></div>
        </Skeleton>
      </div>
    </div>
  )
}

export default OrderSummaryLoader
